import React from 'react';
import {
  Typography,
  Divider
} from '@material-ui/core';
import format from 'date-fns/format';
import { AutomaticPromotionSummaryProps } from './promotion';


const AutomaticPromotionSummary: React.FC<AutomaticPromotionSummaryProps> = ({ values }) => {
  return (
    <>
      <Typography variant="h5" className="font-bold mb-3 uppercase">
        Summary
      </Typography>
      <Divider className="mb-3" />
      {!!values.title.length &&
      <>
        <Typography variant="h5" className="font-bold text-13">
          Promotion Title
        </Typography>
        <ul className="my-2 text-13 pl-6">
          <li>{values.title}</li>
        </ul>
      </>
      }
      {(!!values.discountType.name.length  ||  values.freeShipping.active) &&
      <>
        <Typography variant="h5" className="font-bold text-13">
          Discount Type
        </Typography>
        {values.percentageOff.isActive &&
          <>
            {!!values.percentageOff.discount.length &&
              <ul className="my-2 text-13 pl-6">
                <li>{values.percentageOff.discount} OFF</li>
              </ul>
            }
            {!!values.percentageOff.appliesTo.name.length &&
            <>
              <Typography variant="h5" className="font-bold text-13">
                Applies To:
              </Typography>
              {
                (
                  values.percentageOff.appliesTo.name === 'Storewide'
                  || values.percentageOff.appliesTo.name === 'All Products'
                  || values.percentageOff.appliesTo.name === 'All Treatments'
                ) ?
                  <ul className="my-2 text-13 pl-6">
                    <li>{values.percentageOff.appliesTo.name}</li>
                  </ul>
                  :
                  <ul className="my-2 text-13 pl-6">
                    {values.percentageOff.appliesTo.isCategories &&
                    <>
                      {!!values.percentageOff.appliesTo.value.categories.length &&
                        <li>
                          {'Categories: '}
                          {values.percentageOff.appliesTo.value.categories.map((v, idx) => (
                            <span key={v.id}>
                              {v.name.trim()}
                              {(
                                values.percentageOff.appliesTo.value.categories.length > 1 &&
                                values.percentageOff.appliesTo.value.categories.length !== (idx + 1) &&
                                <>{', '}</>
                              )}
                            </span>
                          ))
                          }
                        </li>
                      }
                    </>
                    }
                    {values.percentageOff.appliesTo.isListings &&
                      <>
                        <li>
                          {'Listings: '}
                          {values.percentageOff.appliesTo.value.listings.map((v, idx) => (
                            <span key={v.id}>
                              {v.name.trim()}
                              {(
                                values.percentageOff.appliesTo.value.listings.length > 1 &&
                                values.percentageOff.appliesTo.value.listings.length !== (idx + 1) &&
                                <>{', '}</>
                              )}
                            </span>
                          ))
                          }
                        </li>
                      </>
                    }
                  </ul>
              }
            </>
            }
            {values.percentageOff.notAppliesTo.name !== 'None' &&
            <>
              <Typography variant="h5" className="font-bold text-13">
                Does Not Applies To:
              </Typography>
              {
                (
                  values.percentageOff.notAppliesTo.name === 'All Products'
                  || values.percentageOff.notAppliesTo.name === 'All Treatments'
                ) ?
                  <ul className="my-2 text-13 pl-6">
                    <li>{values.percentageOff.notAppliesTo.name}</li>
                  </ul>
                  :
                  <ul className="my-2 text-13 pl-6">
                    {values.percentageOff.notAppliesTo.isCategories &&
                    <>
                      {!!values.percentageOff.notAppliesTo.value.categories.length &&
                        <li>
                          {'Categories: '}
                          {values.percentageOff.notAppliesTo.value.categories.map((v, idx) => (
                            <span key={v.id}>
                              {v.name.trim()}
                              {(
                                values.percentageOff.notAppliesTo.value.categories.length > 1 &&
                                values.percentageOff.notAppliesTo.value.categories.length !== (idx + 1) &&
                                <>{', '}</>
                              )}
                            </span>
                          ))
                          }
                        </li>
                      }
                    </>
                    }
                    {values.percentageOff.notAppliesTo.isListings &&
                      <>
                        <li>
                          {'Listings: '}
                          {values.percentageOff.notAppliesTo.value.listings.map((v, idx) => (
                            <span key={v.id}>
                              {v.name.trim()}
                              {(
                                values.percentageOff.notAppliesTo.value.listings.length > 1 &&
                                values.percentageOff.notAppliesTo.value.listings.length !== (idx + 1) &&
                                <>{', '}</>
                              )}
                            </span>
                          ))
                          }
                        </li>
                      </>
                    }
                  </ul>
              }
            </>
            }
          </>
        }
        {values.dollarOff.isActive &&
          <>
            {!!values.dollarOff.discount.length &&
              <ul className="my-2 text-13 pl-6">
                <li>
                  {values.dollarOff.discount}{' OFF '}
                  {values.dollarOff.discountTo.length &&
                    <>
                      {
                        values.dollarOff.discountTo === 'by_fixed'
                          ? 'for each item'
                          : 'for whole cart'
                      }
                    </>
                  }
                </li>
              </ul>
            }
            {!!values.dollarOff.appliesTo.name.length &&
            <>
              <Typography variant="h5" className="font-bold text-13">
                Applies To:
              </Typography>
              {
                (
                  values.dollarOff.appliesTo.name === 'Storewide'
                  || values.dollarOff.appliesTo.name === 'All Products'
                  || values.dollarOff.appliesTo.name === 'All Treatments'
                ) ?
                  <ul className="my-2 text-13 pl-6">
                    <li>{values.dollarOff.appliesTo.name}</li>
                  </ul>
                  :
                  <ul className="my-2 text-13 pl-6">
                    {values.dollarOff.appliesTo.isCategories &&
                    <>
                      {!!values.dollarOff.appliesTo.value.categories.length &&
                        <li>
                          {'Categories: '}
                          {values.dollarOff.appliesTo.value.categories.map((v, idx) => (
                            <span key={v.id}>
                              {v.name.trim()}
                              {(
                                values.dollarOff.appliesTo.value.categories.length > 1 &&
                                values.dollarOff.appliesTo.value.categories.length !== (idx + 1) &&
                                <>{', '}</>
                              )}
                            </span>
                          ))
                          }
                        </li>
                      }
                    </>
                    }
                    {values.dollarOff.appliesTo.isListings &&
                      <>
                        <li>
                          {'Listings: '}
                          {values.dollarOff.appliesTo.value.listings.map((v, idx) => (
                            <span key={v.id}>
                              {v.name.trim()}
                              {(
                                values.dollarOff.appliesTo.value.listings.length > 1 &&
                                values.dollarOff.appliesTo.value.listings.length !== (idx + 1) &&
                                <>{', '}</>
                              )}
                            </span>
                          ))
                          }
                        </li>
                      </>
                    }
                  </ul>
              }
            </>
            }
            {values.dollarOff.notAppliesTo.name !== 'None' &&
            <>
              <Typography variant="h5" className="font-bold text-13">
                Does Not Applies To:
              </Typography>
              {
                (
                  values.dollarOff.notAppliesTo.name === 'All Products'
                  || values.dollarOff.notAppliesTo.name === 'All Treatments'
                ) ?
                  <ul className="my-2 text-13 pl-6">
                    <li>{values.dollarOff.notAppliesTo.name}</li>
                  </ul>
                  :
                  <ul className="my-2 text-13 pl-6">
                    {values.dollarOff.notAppliesTo.isCategories &&
                    <>
                      {!!values.dollarOff.notAppliesTo.value.categories.length &&
                        <li>
                          {'Categories: '}
                          {values.dollarOff.notAppliesTo.value.categories.map((v, idx) => (
                            <span key={v.id}>
                              {v.name.trim()}
                              {(
                                values.dollarOff.notAppliesTo.value.categories.length > 1 &&
                                values.dollarOff.notAppliesTo.value.categories.length !== (idx + 1) &&
                                <>{', '}</>
                              )}
                            </span>
                          ))
                          }
                        </li>
                      }
                    </>
                    }
                    {values.dollarOff.notAppliesTo.isListings &&
                      <>
                        <li>
                          {'Listings: '}
                          {values.dollarOff.notAppliesTo.value.listings.map((v, idx) => (
                            <span key={v.id}>
                              {v.name.trim()}
                              {(
                                values.dollarOff.notAppliesTo.value.listings.length > 1 &&
                                values.dollarOff.notAppliesTo.value.listings.length !== (idx + 1) &&
                                <>{', '}</>
                              )}
                            </span>
                          ))
                          }
                        </li>
                      </>
                    }
                  </ul>
              }
            </>
            }
          </>
        }
        {values.fixedPrice.isActive &&
          <>
            {!!values.fixedPrice.price.length &&
              <ul className="my-2 text-13 pl-6">
                <li>Fixed price {values.fixedPrice.price}</li>
              </ul>
            }
            {!!values.fixedPrice.appliesTo.name.length &&
            <>
              <Typography variant="h5" className="font-bold text-13">
                Applies To:
              </Typography>
              {
                (
                  values.fixedPrice.appliesTo.name === 'Storewide'
                  || values.fixedPrice.appliesTo.name === 'All Products'
                  || values.fixedPrice.appliesTo.name === 'All Treatments'
                ) ?
                  <ul className="my-2 text-13 pl-6">
                    <li>{values.fixedPrice.appliesTo.name}</li>
                  </ul>
                  :
                  <ul className="my-2 text-13 pl-6">
                    {values.fixedPrice.appliesTo.isCategories &&
                    <>
                      {!!values.fixedPrice.appliesTo.value.categories.length &&
                        <li>
                          {'Categories: '}
                          {values.fixedPrice.appliesTo.value.categories.map((v, idx) => (
                            <span key={v.id}>
                              {v.name.trim()}
                              {(
                                values.fixedPrice.appliesTo.value.categories.length > 1 &&
                                values.fixedPrice.appliesTo.value.categories.length !== (idx + 1) &&
                                <>{', '}</>
                              )}
                            </span>
                          ))
                          }
                        </li>
                      }
                    </>
                    }
                    {values.fixedPrice.appliesTo.isListings &&
                      <>
                        <li>
                          {'Listings: '}
                          {values.fixedPrice.appliesTo.value.listings.map((v, idx) => (
                            <span key={v.id}>
                              {v.name.trim()}
                              {(
                                values.fixedPrice.appliesTo.value.listings.length > 1 &&
                                values.fixedPrice.appliesTo.value.listings.length !== (idx + 1) &&
                                <>{', '}</>
                              )}
                            </span>
                          ))
                          }
                        </li>
                      </>
                    }
                  </ul>
              }
            </>
            }
            {values.fixedPrice.notAppliesTo.name !== 'None' &&
            <>
              <Typography variant="h5" className="font-bold text-13">
                Does Not Applies To:
              </Typography>
              {
                (
                  values.fixedPrice.notAppliesTo.name === 'All Products'
                  || values.fixedPrice.notAppliesTo.name === 'All Treatments'
                ) ?
                  <ul className="my-2 text-13 pl-6">
                    <li>{values.fixedPrice.notAppliesTo.name}</li>
                  </ul>
                  :
                  <ul className="my-2 text-13 pl-6">
                    {values.fixedPrice.notAppliesTo.isCategories &&
                    <>
                      {!!values.fixedPrice.notAppliesTo.value.categories.length &&
                        <li>
                          {'Categories: '}
                          {values.fixedPrice.notAppliesTo.value.categories.map((v, idx) => (
                            <span key={v.id}>
                              {v.name.trim()}
                              {(
                                values.fixedPrice.notAppliesTo.value.categories.length > 1 &&
                                values.fixedPrice.notAppliesTo.value.categories.length !== (idx + 1) &&
                                <>{', '}</>
                              )}
                            </span>
                          ))
                          }
                        </li>
                      }
                    </>
                    }
                    {values.fixedPrice.notAppliesTo.isListings &&
                      <>
                        <li>
                          {'Listings: '}
                          {values.fixedPrice.notAppliesTo.value.listings.map((v, idx) => (
                            <span key={v.id}>
                              {v.name.trim()}
                              {(
                                values.fixedPrice.notAppliesTo.value.listings.length > 1 &&
                                values.fixedPrice.notAppliesTo.value.listings.length !== (idx + 1) &&
                                <>{', '}</>
                              )}
                            </span>
                          ))
                          }
                        </li>
                      </>
                    }
                  </ul>
              }
            </>
            }
          </>
        }
        {values.buyXGetY.isActive &&
          <>
            {!!values.buyXGetY.customerBuys.minBuy.value.length &&
              <ul className="my-2 text-13 pl-6">
                <li>
                  Buy {values.buyXGetY.customerBuys.minBuy.value}{' '}
                  {
                    (values.buyXGetY.customerBuys.appliesTo.name === 'Storewide'
                      || values.buyXGetY.customerBuys.appliesTo.name === 'All Products'
                      || values.buyXGetY.customerBuys.appliesTo.name === 'All Treatments'
                    )
                      ?
                      values.buyXGetY.customerBuys.appliesTo.name
                      :
                      <>
                        {values.buyXGetY.customerBuys.appliesTo.value.categories.map((v) => v.name.trim()).join(', ')}{', '}
                        {values.buyXGetY.customerBuys.appliesTo.value.listings.map((v) => v.name.trim()).join(', ')}{', '}
                      </>
                  }
                  {!!values.buyXGetY.customerGet.quantity.length &&
                    <>
                      Get {values.buyXGetY.customerGet.quantity}{' '}
                      {values.buyXGetY.customerGet.appliesTo.value.categories.map((v) => v.name.trim()).join(', ')}{', '}
                      {values.buyXGetY.customerGet.appliesTo.value.listings.map((v) => v.name.trim()).join(', ')}
                    </>
                  }
                  {(!!values.buyXGetY.discountValue.name.length &&
                    !!values.buyXGetY.discountValue.value.length
                  ) &&
                    <>
                      {
                        (
                          values.buyXGetY.discountValue.name === 'Percentage OFF'
                            || values.buyXGetY.discountValue.name === 'Dollar OFF'
                        ) ?
                          <>
                            {'with '}{values.buyXGetY.discountValue.value}{' OFF'}
                          </>
                          :
                          <>
                            {'with fixed price '}{values.buyXGetY.discountValue.value}
                          </>
                      }
                    </>
                  }
                </li>
              </ul>
            }
          </>
        }
        {values.everyNth.isActive &&
        <>
          {(!!values.everyNth.discountOn.name.length &&
            !!values.everyNth.discountOn.value.length
          ) &&
          <ul className="my-2 text-13 pl-6">
            <li>
              {values.everyNth.discountOn.value.includes('$') ?
                <>
                  {`Every ${values.everyNth.discountOn.value} purchase amount `}
                </>
                :
                <>
                  {`Every ${values.everyNth.discountOn.value} quantity of item `}
                </>
              }
              {(!!values.everyNth.discountValue.name.length &&
                    !!values.everyNth.discountValue.value.length
              ) &&
              <>
                {
                  (
                    values.everyNth.discountValue.name === 'Percentage OFF'
                            || values.everyNth.discountValue.name === 'Dollar OFF'
                  ) ?
                    <>
                      {'with '}{values.everyNth.discountValue.value}{' OFF'}
                    </>
                    :
                    <>
                      {'with fixed price '}{values.everyNth.discountValue.value}
                    </>
                }
              </>
              }
            </li>
          </ul>
          }
          {!!values.everyNth.appliesTo.name.length &&
            <>
              <Typography variant="h5" className="font-bold text-13">
                Applies To:
              </Typography>
              {
                (
                  values.everyNth.appliesTo.name === 'Storewide'
                  || values.everyNth.appliesTo.name === 'All Products'
                  || values.everyNth.appliesTo.name === 'All Treatments'
                ) ?
                  <ul className="my-2 text-13 pl-6">
                    <li>{values.everyNth.appliesTo.name}</li>
                  </ul>
                  :
                  <ul className="my-2 text-13 pl-6">
                    {values.everyNth.appliesTo.isCategories &&
                    <>
                      {!!values.everyNth.appliesTo.value.categories.length &&
                        <li>
                          {'Categories: '}
                          {values.everyNth.appliesTo.value.categories.map((v, idx) => (
                            <span key={v.id}>
                              {v.name.trim()}
                              {(
                                values.everyNth.appliesTo.value.categories.length > 1 &&
                                values.everyNth.appliesTo.value.categories.length !== (idx + 1) &&
                                <>{', '}</>
                              )}
                            </span>
                          ))
                          }
                        </li>
                      }
                    </>
                    }
                    {values.everyNth.appliesTo.isListings &&
                      <>
                        <li>
                          {'Listings: '}
                          {values.everyNth.appliesTo.value.listings.map((v, idx) => (
                            <span key={v.id}>
                              {v.name.trim()}
                              {(
                                values.everyNth.appliesTo.value.listings.length > 1 &&
                                values.everyNth.appliesTo.value.listings.length !== (idx + 1) &&
                                <>{', '}</>
                              )}
                            </span>
                          ))
                          }
                        </li>
                      </>
                    }
                  </ul>
              }
            </>
          }
          {values.everyNth.notAppliesTo.name !== 'None' &&
            <>
              <Typography variant="h5" className="font-bold text-13">
                Does Not Applies To:
              </Typography>
              {
                (
                  values.everyNth.notAppliesTo.name === 'All Products'
                  || values.everyNth.notAppliesTo.name === 'All Treatments'
                ) ?
                  <ul className="my-2 text-13 pl-6">
                    <li>{values.everyNth.notAppliesTo.name}</li>
                  </ul>
                  :
                  <ul className="my-2 text-13 pl-6">
                    {values.everyNth.notAppliesTo.isCategories &&
                    <>
                      {!!values.everyNth.notAppliesTo.value.categories.length &&
                        <li>
                          {'Categories: '}
                          {values.everyNth.notAppliesTo.value.categories.map((v, idx) => (
                            <span key={v.id}>
                              {v.name.trim()}
                              {(
                                values.everyNth.notAppliesTo.value.categories.length > 1 &&
                                values.everyNth.notAppliesTo.value.categories.length !== (idx + 1) &&
                                <>{', '}</>
                              )}
                            </span>
                          ))
                          }
                        </li>
                      }
                    </>
                    }
                    {values.everyNth.notAppliesTo.isListings &&
                      <>
                        <li>
                          {'Listings: '}
                          {values.everyNth.notAppliesTo.value.listings.map((v, idx) => (
                            <span key={v.id}>
                              {v.name.trim()}
                              {(
                                values.everyNth.notAppliesTo.value.listings.length > 1 &&
                                values.everyNth.notAppliesTo.value.listings.length !== (idx + 1) &&
                                <>{', '}</>
                              )}
                            </span>
                          ))
                          }
                        </li>
                      </>
                    }
                  </ul>
              }
            </>
          }
        </>
        }
        {values.bundle.isActive &&
        <>
          {(!!values.bundle.appliesTo.name.length &&
            !!values.bundle.appliesTo.value.length
          ) &&
          <ul className="my-2 text-13 pl-6">
            <li>
              {values.bundle.appliesTo.value.map((v) => v.name.trim()).join(', ')}{' '}
              {(!!values.bundle.discountValue.name.length &&
                    !!values.bundle.discountValue.value.length
              ) &&
              <>
                {
                  (
                    values.bundle.discountValue.name === 'Percentage OFF'
                            || values.bundle.discountValue.name === 'Dollar OFF'
                  ) ?
                    <>
                      {'with '}{values.bundle.discountValue.value}{' OFF'}
                    </>
                    :
                    <>
                      {'with fixed price '}{values.bundle.discountValue.value}
                    </>
                }
              </>
              }
            </li>
          </ul>
          }
        </>
        }
        {values.freeShipping.active &&
          <ul className="my-2 text-13 pl-6">
            <li>
              Free Shipping on All Products
            </li>
          </ul>
        }
      </>
      }
      {!(values.discountType.value === 'buyXGetY'
        || values.discountType.value === 'everyNth') &&
        !!values.minOrderAmount.name.length &&
        <>
          <Typography variant="h5" className="font-bold text-13">
            Minimum order to qualify
          </Typography>
          <ul className="my-2 text-13 pl-6">
            <li>
              {values.minOrderAmount.name === 'None' && 'None'}
              {values.minOrderAmount.name !== 'None' && values.minOrderAmount.value}
            </li>
          </ul>
        </>
      }
      {!!values.customerGroups.name.length &&
        <>
          <Typography variant="h5" className="font-bold text-13">
            Customer Eligibility:
          </Typography>
          <ul className="my-2 text-13 pl-6">
            {
              (values.customerGroups.name === 'Everyone') ?
                <li>
                  Everyone
                </li>
                :
                values.customerGroups.value.map((v) => (
                  <li key={v.id}>
                    {v.code}
                  </li>
                ))
            }
          </ul>
        </>
      }
      {(values.usageLimits.shoppingQuantity.checked
        || values.usageLimits.perCustomer.checked
      ) &&
        <>
          <Typography variant="h5" className="font-bold text-13">
            Usage Limits
          </Typography>
          {values.usageLimits.perCustomer.checked &&
            <ul className="my-2 text-13 pl-6">
              <li>
                Number of times this discount can be used per customer - {values.usageLimits.perCustomer.value}
              </li>
            </ul>
          }
          {values.usageLimits.shoppingQuantity.checked &&
            <ul className="my-2 text-13 pl-6">
              <li>
                Maximum quantity in shopping cart the discount can be applied to - {values.usageLimits.shoppingQuantity.value}
              </li>
            </ul>
          }
        </>
      }
      {Object.values(values.exclusionNotes).find((el) => el.checked) &&
        <>
          <Typography variant="h5" className="font-bold text-13">
            Exclusions
          </Typography>

          {Object.values(values.exclusionNotes).map((el) => el.checked ?
            <ul key={el.name} className="my-2 text-13 pl-6">
              <li>{el.name}</li>
            </ul>
            :
            ''
          )}
        </>
      }
      {(values.dates.startDate) &&
        <>
          <Typography variant="h5" className="font-bold text-13">
            Active Dates
          </Typography>
          <ul className="my-2 text-13 pl-6">
            <li>
              Active from {format(values.dates.startDate, 'MMM d yyyy')}{' '}
              <span className="uppercase">
                {/* {values.dates.startTime && format(values.dates.startTime, "HH:mm aaaaa'm'")} */}
                {values.dates.startTime}
              </span>
              {(values.dates.isEndDates && values.dates.endDate) &&
                <>
                  {' to'} {format(values.dates.endDate, 'MMM d yyyy')}{' '}
                  <span className="uppercase">
                    {/* {values.dates.endTime && format(values.dates.endTime, "HH:mm aaaaa'm'")} */}
                    {values.dates.endTime}
                  </span>
                </>
              }
            </li>
          </ul>
        </>
      }
      {!!values.uploadFile.length &&
        <>
          <Typography variant="h5" className="font-bold text-13">
            File Upload
          </Typography>
          <ul className="my-2 text-13 pl-6">
            {values.uploadFile.map((el) => el.filename &&
              <li key={el.filename} >{el.filename}</li>
            )}
          </ul>
        </>
      }
    </>
  );
};

export default AutomaticPromotionSummary;
